import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { UISettingsProvider } from './context/UISettingsContext';
import './index.css';
import './styles/UiKit.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const BUILD_SIGNATURE_KEY = 'app_build_signature';
const UPDATE_RELOAD_FLAG = '__ipys_update_reload_in_progress';
const UPDATE_CHECK_INTERVAL_MS = Number(process.env.REACT_APP_UPDATE_CHECK_INTERVAL_MS || 60 * 1000);
const UPDATE_LOGOUT_REASON = 'Uygulama güncellendi. Lütfen tekrar giriş yapın.';

const clearAuthForUpdate = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('session_last_activity_ms');
  localStorage.removeItem('session_started_at_ms');
  localStorage.setItem('auth_logout_reason', UPDATE_LOGOUT_REASON);
};

const redirectToLogin = () => {
  if (window.location.hash !== '#/login') {
    window.location.hash = '#/login';
  }
};

const applyUpdateLogoutAndReload = () => {
  if (sessionStorage.getItem(UPDATE_RELOAD_FLAG) === '1') return;
  sessionStorage.setItem(UPDATE_RELOAD_FLAG, '1');
  clearAuthForUpdate();
  redirectToLogin();
  window.location.reload();
};

const checkForNewBuild = async () => {
  try {
    const base = process.env.PUBLIC_URL || '';
    const response = await fetch(`${base}/asset-manifest.json?ts=${Date.now()}`, {
      cache: 'no-store',
    });
    if (!response.ok) return;
    const manifest = await response.json();
    const files = manifest?.files || {};
    const signature = [files['main.js'] || '', files['main.css'] || ''].join('|');
    if (!signature) return;

    const previous = localStorage.getItem(BUILD_SIGNATURE_KEY);
    if (!previous) {
      localStorage.setItem(BUILD_SIGNATURE_KEY, signature);
      return;
    }

    if (previous !== signature) {
      localStorage.setItem(BUILD_SIGNATURE_KEY, signature);
      applyUpdateLogoutAndReload();
    }
  } catch (error) {
    // no-op
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <UISettingsProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </UISettingsProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();

checkForNewBuild();
window.setInterval(checkForNewBuild, UPDATE_CHECK_INTERVAL_MS);

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;
  let hasControllerChangeHandled = false;

  const triggerWaitingWorker = (registration) => {
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hasControllerChangeHandled) return;
    hasControllerChangeHandled = true;
    applyUpdateLogoutAndReload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        triggerWaitingWorker(registration);

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              triggerWaitingWorker(registration);
            }
          });
        });
      })
      .catch(() => {
        // no-op
      });
  });
}
